
import ProfileTags from "@/components/v2/profile-tags.vue";
import ProfileMenuV2 from "~/components/v2/common/profiles/profile-menu-v2.vue";

export default {
  components: {
    ProfileTags,
    ProfileMenuV2,
  },

  inject: { decodedDistrictId: { default: undefined } },

  props: {
    profile: {
      type: Object,
      required: true,
    },

    cardData: {
      type: Object,
      default: () => ({}),
    },

    bordered: {
      type: Boolean,
      default: false,
    },

    inFavorites: {
      type: Boolean,
      default: false,
    },

    isFavoriteProcessing: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isMenuOpen: false,
    };
  },

  computed: {
    priceRange() {
      if (!this.cardData?.rates?.length) {
        return { min: null, max: null };
      }

      let min = null;
      let max = null;

      for (const rate of this.cardData.rates) {
        if (rate.price_service_id !== 3 && rate.price > 0) {
          if (min === null) {
            min = max = rate.price;
          } else {
            if (rate.price < min) min = rate.price;
            if (rate.price > max) max = rate.price;
          }
        }
      }

      return { min, max };
    },
  },

  methods: {
    processFavorite(profile) {
      this.$emit("favoriteClicked", profile);
    },
  },
};
